import { OrderedList as TiptapOrderedList } from '@tiptap/extension-ordered-list';
import { mergeAttributes } from '@tiptap/core';
import { optimizeStyle } from './utilityFunctions';
import { commonListAttributes, createToggleListCommand } from './listExtensionsCommon';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    orderedLists: {
      /**
       * Toggle a bullet list with custom bullet style type
       */
      toggleOrderedListContent: (numberingType: string) => ReturnType;
      applyListStyle: (numberingType: string) => ReturnType;
    };
  }
}
export const OrderedList = TiptapOrderedList.extend({
  addAttributes() {
    return {
      ...this.parent?.(),

      listStyleType: {
        default: 'decimal',

        parseHTML: (element) => {
          const style = element.style?.listStyleType;
          const type = element.getAttribute('type');

          if (style) return style;

          switch (type) {
            case 'A':
              return 'upper-alpha';
            case 'a':
              return 'lower-alpha';
            case 'I':
              return 'upper-roman';
            case 'i':
              return 'lower-roman';
            default:
              return 'decimal';
          }
        },

        renderHTML: (attrs) => {
          if (!attrs.listStyleType) return {};
          return { style: `list-style-type: ${attrs.listStyleType}` };
        },
      },
      ...commonListAttributes,
    };
  },

  renderHTML({ HTMLAttributes }) {
    const { start, ...rest } = HTMLAttributes;

    return start === 1
      ? ['ol', optimizeStyle(mergeAttributes(this.options.HTMLAttributes, rest)), 0]
      : ['ol', optimizeStyle(mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)), 0];
  },

  addCommands() {
    return {
      ...this.parent?.(),

      toggleOrderedListContent: createToggleListCommand('orderedList'),
    };
  },
});
